var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-breadcrumb',{style:({ margin: '16px 0', padding: '0 50px' })},[_c('a-breadcrumb-item',[_c('span',[_vm._v(" 个人资料 ")])])],1),_c('a-layout-content',{staticClass:"content-wrapper"},[_c('user-info')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }